export default () =>
  import(
    /* webpackChunkName: 'coffee/app/download/office-automation' */ './OfficeAutomation'
  );
